<template>
  <div>
    <app-header
      :title="originalName ? 'Edit' + originalName : 'New Manufacturer'"
      subtitle="Manufacturer"
    >
      <b-button variant="primary" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container v-if="manufacturer">
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <!--Name-->
            <b-form-group>
              <label>Name</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="manufacturer.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>

            <!--Thumbnail-->
            <b-form-group>
              <label>Thumbnail</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <FileInput
                v-model="manufacturer.thumbnail"
                required
                folder="manufacturer/thumbnail"
              />
            </b-form-group>

            <!--Featured-->
            <b-form-group>
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    v-model="manufacturer.featured"
                    class="form-check-input"
                    type="checkbox"
                  />
                  Featured
                </label>
              </div>
            </b-form-group>
          </b-form>
        </b-col>
        <div class="col col-md-8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import FileInput from '@/components/FileInput';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    CancelButton,
    FileInput,
  },

  data() {
    return {
      originalName: null,
      manufacturer: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      if (this.$route.query.id) {
        this.manufacturer = await $api.get(
          `/v1/internal/manufacturers/${this.$route.query.id}`,
        );
        this.originalName = this.manufacturer.name;
      } else {
        this.manufacturer = {};
      }
    },

    async save() {
      let manufacturer;
      if (this.manufacturer.id) {
        manufacturer = await $api.put(
          `/v1/internal/manufacturers/${this.manufacturer.id}`,
          this.manufacturer,
        );
      } else {
        manufacturer = await $api.post(
          '/v1/internal/manufacturers',
          this.manufacturer,
        );
      }
      this.$router.push({
        name: 'manufacturer-detail',
        params: manufacturer,
      });
    },
  },
};
</script>
